import { ReactNode } from "react";

type EmptyStateVariant = "default" | "success" | "danger";

type EmptyStateProps = {
  description: ReactNode;
  /**
   * Indhold under beskrivelsen. Beskrivelsen ligger i et `<p>`, saa alt med knapper eller
   * blokelementer skal herned i stedet.
   */
  footer?: ReactNode;
  icon: ReactNode;
  title: ReactNode;
  variant?: EmptyStateVariant;
};

const EmptyState = ({
  description,
  footer,
  icon,
  title,
  variant = "default",
}: EmptyStateProps) => {
  const variantClassName =
    variant === "default"
      ? ""
      : ` cle-compliance-doc-dashboard__empty-state--${variant}`;

  return (
    <div
      className={`cle-compliance-doc-dashboard__empty-state${variantClassName}`}
    >
      <span
        className="cle-compliance-doc-dashboard__empty-icon"
        aria-hidden="true"
      >
        {icon}
      </span>
      <p className="cle-compliance-doc-dashboard__empty-title">{title}</p>
      <p className="cle-compliance-doc-dashboard__empty-description">
        {description}
      </p>
      {footer ? (
        <div className="cle-compliance-doc-dashboard__empty-footer">
          {footer}
        </div>
      ) : null}
    </div>
  );
};

export default EmptyState;
